export default "__VITE_ASSET__BXBrGRIR__"